import {Component, Input, OnInit, input} from '@angular/core';
import {EsploroAssetForPortalFullAssetPage} from '../../../shared/interfaces/research-portal/full-asset-page/esploro-asset-for-portal-full-asset-page.interface';
import {UrlUtils} from '../../../shared/utils/url.utils';
import {FullAssetPageEssentialsConfiguration} from '../../../shared/interfaces/research-portal/portal-configuration/full-asset-page-essentials-configuration.interface';
import { HtmlStripPipe } from '@exl-ng/mulo-common';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgSwitch, NgIf, NgSwitchCase, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'esp-asset-page-metadata-essentials',
    templateUrl: './asset-page-metadata-essentials.component.html',
    styleUrls: ['./asset-page-metadata-essentials.component.scss'],
    imports: [NgFor, NgSwitch, NgIf, NgSwitchCase, NgTemplateOutlet, TranslateModule, HtmlStripPipe]
})
export class AssetPageMetadataEssentialsComponent implements OnInit {

    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() fullAssetPageRep: EsploroAssetForPortalFullAssetPage;
    readonly essentials = input<FullAssetPageEssentialsConfiguration[]>(undefined);

    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() assetsIdentifiersToDisplay;


    constructor() { }

    ngOnInit(): void {
    }

    isAvailableIdentifiersToDisplay(){
        if (this.assetsIdentifiersToDisplay && Object.keys(this.assetsIdentifiersToDisplay).length > 0){
            return true;
        }
        return false;
    }

    getAvailableIdentifiersToDisplay(){
        return Object.keys(this.assetsIdentifiersToDisplay);
    }

    isLink(str, identifierName: string){
        return (UrlUtils.isURL(str));
    }

    isDoiOrHandleExternal(identifierName: string){
        return (this.isDoiAndExternal(identifierName) ||
                    this.isHandleAndExternal(identifierName));
    }

    isDoiAndExternal(identifierName: string){

        if(identifierName.toLowerCase()==='doi'){
            if(this.fullAssetPageRep.isExternalDOI){
                return true;
            }
        }
        return false;
    }

    isHandleAndExternal(identifierName: string){

        if(identifierName.toLowerCase()==='handle'){
            if(this.fullAssetPageRep.isExternalHandle){
                return true;
            }
        }
        return false;
    }








}
